import { IRootState } from '../reducer';

export const selectIsVariantContext = (rootState: IRootState): boolean => !!rootState.variantContext.variantId;

export const selectVariantContextId = (rootState: IRootState): string | undefined => rootState.variantContext.variantId;
export const selectVariantContextError = (rootState: IRootState): string | undefined => rootState.variantContext.error;
